<template>
  <div>
    <div v-for="call in report.calls" v-bind:key="call.opened" class="card call-card"
        v-bind:class="{'answered': call.answered, 'voicemail': call.voicemail_left, 'noring': call.attempts === 0}">
      <div class="card-heading call-heading d-flex" data-toggle="collapse" v-bind:href="'#id-'+call.opened">
        <span class="card-title call-title">
          Call from {{call.from}}
          <span v-if="call.answered">successfully answered</span>
          <span v-else-if="call.voicemail_left">left a voicemail</span>
          <span v-else-if="call.attempts === 0">failed to call base2</span>
        </span>
        <span class="ml-auto">({{call.opened | moment('MMM Do, h:mm a')}})</span>
      </div>
      <div v-bind:id="'id-'+call.opened" class="card-collapse collapse">
        <ul>
          <li class="call-collapse">Call made to the {{call.region}} region</li>
          <li class="call-collapse">OpsGenie attempted to call {{call.attempts}} times</li>
          <li class="call-collapse" v-if="call.answered">Answered in {{call.answered}} seconds</li>
          <li class="call-collapse" v-if="call.completed">Call completed in {{call.completed}} seconds</li>
          <li class="call-collapse" v-if="call.voicemail_left"><a :href="call.voicemail_link">Listen to voicemail</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallLogs',
  props: [
    'report'
  ]
}
</script>

<style scoped src='../assets/stylesheet/components/call-logs.css'></style>



// WEBPACK FOOTER //
// src/components/CallLogs.vue